import styled from 'styled-components';
import chevrondown from '@/assets/Icons/chevron-down.svg';

export const Container = styled.div`
    display: flex;
    padding: var(--spacing-24px, 24px) var(--spacing-16px, 16px);
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-16px, 16px);
    flex-shrink: 0;
    align-self: stretch;
    background: var(--Surface-White, #fff);
`;

export const Heading = styled.div`
    align-items: flex-start;
    align-self: stretch;
    color: var(--Text-Primary-grey600, #121212);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
`;

export const ListItems = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-16px, 16px);
    align-self: stretch;
`;

export const ListComponent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    border-bottom: 1px solid var(--Border-Default-grey100, #e8e8e8);
`;

export const ListItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center; /* Center align vertically */
    padding: 12px 0;
    flex-direction: row; /* Ensure horizontal layout */
    gap: var(--spacing-16px, 16px);
    align-self: stretch;

    color: var(--Text-Primary-grey600, #121212);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
`;

export const ChevronDown = styled(chevrondown)`
    width: 16px;
    height: 16px;

    &.rotated {
        transform: rotate(180deg);
    }
`;

export const DropdownContent = styled.div`
    padding: 0 0 12px 0;
    color: var(--Text-Secondary-grey400, #4b4b4b);
    font-family: 'Euclid Circular B';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;
